import React from 'react'
import classnames from 'classnames/bind'

import Title from 'components/typo/Title'
import IconTitleText from 'components/shared/IconTitleText'

import css from './styles.module.scss'

const cx = classnames.bind(css)

const FeaturesList = ({ className, title, cards, iconLayout, layout }) => {
  return (
    <div className={cx(css.Features, className, layout)}>
      {title && <Title className={css.title}>{title}</Title>}
      <div className={css.items}>
        {cards &&
          cards.map((item, i) => (
            <IconTitleText
              key={`features-list-${title}-${i}`}
              index={i}
              className={css.item}
              iconLayout={iconLayout}
              {...item}
            />
          ))}
      </div>
    </div>
  )
}

FeaturesList.defaultProps = {
  column: true,
}

export default FeaturesList
